<script>
import FileWrapper from '@/components/modules/Files/layouts/FileWrapper'

export default {
  name: 'LayoutStandard',
  inheritAttrs: false,
  functional: true,
  render (createElement, context) {
    return context.children.map(c => {
      return createElement(
        FileWrapper,
        {
          class: 'file'
        },
        [c])
    })
  }
}
</script>
